// Code generated by hack/generate-icons-typescript.sh; DO NOT EDIT.
/* eslint-disable prettier/prettier */

// resourceIconGroups is a map of resource kind globs to whether or not a custom icon exists for that kind.
// Each glob corresponds to a directory under ui/src/assets/images/resources, where any asterisk is represented as an underscore (_).
export const resourceIconGroups = {
    'cassandra.rook.io': true,
    'cert-manager.io': true,
    'core.spinkube.dev': true,
    '*.crossplane.io': true,
    'external-secrets.io': true,
    'flagger.app': true,
    '*.fluxcd.io': true,
    'install.istio.io': true,
    'jaegertracing.io': true,
    'k8s.keycloak.org': true,
    'kafka.strimzi.io': true,
    'keda.sh': true,
    '*.knative.dev': true,
    'kubevirt.io': true,
    'kyverno.io': true,
    'nauth.io': true,
    'opentelemetry.io': true,
    'projectcontour.io': true,
    'work.karmada.io': true,
    'zookeeper.pravega.io': true,
};
